/**
 * Maskavo motion — reveal + parallax dos cookies + Nina peek.
 */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const pageWrapper = document.querySelector('.page-wrapper');

  const selector = [
    '.mk-reveal',
    '.mk-hh__copy',
    '.mk-hh__visual',
    '.mk-bi__frame',
    '.mk-ba__frame',
    '.mk-ct__head',
    '.mk-ct__cell',
    '.mk-ct__foot',
    '.mk-bs__aside',
    '.mk-bs__carousel',
    '.mk-bs__card',
    '.mk-nv__head',
    '.mk-nv__card',
    '.mk-nv__foot',
    '.mk-pr__card',
    '.mk-bn__head',
    '.mk-bn__item',
    '.mk-ab__media',
    '.mk-ab__copy',
    '.mk-dp__head-text',
    '.mk-dp__track',
    '.mk-ig__head',
    '.mk-ig__cell',
    '.mk-ig__foot',
    '.mk-ap__inner > *',
    '.mk-st__wrap',
    '.mk-cf__inner',
    '.mk-fq__inner > *',
    '.mk-pd__gallery',
    '.mk-pd__buy',
    '.mk-ft__brand',
    '.mk-ft__col',
    '.mk-ft__contact',
  ].join(',');

  const targets = [...document.querySelectorAll(selector)];

  if (targets.length) {
    if (reduce) {
      targets.forEach((el) => el.classList.add('is-in'));
    } else {
      targets.forEach((el) => el.classList.add('mk-reveal'));

      document
        .querySelectorAll('.mk-bs__track, .mk-bs__grid, .mk-nv__grid, .mk-pr__grid, .mk-bn__list, .mk-ct__grid, .mk-ig__grid')
        .forEach((group) => {
          [...group.children].forEach((el, i) => {
            if (!el.classList.contains('mk-reveal')) return;
            el.style.setProperty('--mk-reveal-delay', `${Math.min(i, 5) * 50}ms`);
          });
        });

      const ioRoot =
        pageWrapper && getComputedStyle(pageWrapper).overflowY !== 'visible'
          ? pageWrapper
          : null;

      const heroSection = document.querySelector('.mk-hh');
      const heroVisual = heroSection?.querySelector('.mk-hh__visual');
      const heroCopy = heroSection?.querySelector('.mk-hh__copy');
      const heroTargets = heroSection
        ? targets.filter((el) => heroSection.contains(el))
        : [];
      const nonHeroTargets = heroSection
        ? targets.filter((el) => !heroSection.contains(el))
        : targets;

      const revealIn = (el) => {
        el.classList.add('is-in');
      };

      const observeReveal = (elements, options = {}) => {
        const observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              revealIn(entry.target);
              observer.unobserve(entry.target);
            }
          },
          {
            root: ioRoot,
            rootMargin: options.rootMargin ?? '0px 0px -4% 0px',
            threshold: options.threshold ?? 0.05,
          }
        );

        elements.forEach((el) => {
          const rect = el.getBoundingClientRect();
          const inView = rect.top < window.innerHeight * 0.95 && rect.bottom > 0;
          if (inView) {
            revealIn(el);
          } else {
            observer.observe(el);
          }
        });
      };

      const observeEarly = (el, options = {}) => {
        if (!el) return;
        el.classList.add('mk-reveal');

        const observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              revealIn(entry.target);
              observer.unobserve(entry.target);
            }
          },
          {
            root: ioRoot,
            rootMargin: options.rootMargin ?? '0px 0px 25% 0px',
            threshold: options.threshold ?? 0,
          }
        );

        const rect = el.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight * 0.98) {
          revealIn(el);
        } else {
          observer.observe(el);
        }
      };

      if (isMobile && heroSection && heroVisual) {
        observeEarly(heroVisual, { rootMargin: '0px 0px 30% 0px', threshold: 0 });
        observeEarly(heroCopy, { rootMargin: '0px 0px 20% 0px', threshold: 0 });
        observeReveal(nonHeroTargets);
      } else if (heroSection && heroTargets.length) {
        observeReveal(heroTargets);
        observeReveal(nonHeroTargets);
      } else {
        observeReveal(targets);
      }
    }
  }

  /* —— Parallax cookies + Nina —— */
  let ticking = false;

  const ornaments = [...document.querySelectorAll('[data-mk-parallax]')].map((el) => ({
    el,
    section: el.closest('.shopify-section') || el.parentElement,
    travel: Math.max(160, Math.abs(parseFloat(el.dataset.speed || '0.28')) * 640),
  }));

  const ninaPeeks = [...document.querySelectorAll('[data-mk-nina-peek]')].map((el) => ({
    el,
    section: el.closest('.shopify-section') || el.closest('.mk-ct, .mk-bs, .mk-nv') || el.parentElement,
  }));

  const peekRoot =
    pageWrapper && getComputedStyle(pageWrapper).overflowY !== 'visible' ? pageWrapper : null;

  if (reduce) {
    ornaments.forEach(({ el }) => {
      el.style.setProperty('--mk-orn-y', '0px');
      el.style.setProperty('--mk-orn-rot', '0deg');
      el.style.transform = '';
    });
    ninaPeeks.forEach(({ el }) => el.classList.add('is-peek'));
    return;
  }

  if (isMobile && ninaPeeks.length) {
    const peekObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-peek');
          peekObserver.unobserve(entry.target);
        }
      },
      {
        root: peekRoot,
        rootMargin: '0px 0px 25% 0px',
        threshold: 0,
      }
    );

    ninaPeeks.forEach(({ el }) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        el.classList.add('is-peek');
      } else {
        peekObserver.observe(el);
      }
    });
  }

  if (!ornaments.length && !ninaPeeks.length) return;

  const syncNina = () => {
    if (isMobile) return;

    const vh = window.innerHeight || 1;
    const band = vh * 0.18;

    ninaPeeks.forEach(({ el, section }) => {
      const rect = (section || el).getBoundingClientRect();
      const sectionCenter = rect.top + rect.height / 2;
      const centered = Math.abs(sectionCenter - vh / 2) <= band;
      el.classList.toggle('is-peek', centered);
    });
  };

  const update = () => {
    const vh = window.innerHeight || 1;

    ornaments.forEach(({ el, section, travel }) => {
      const rect = (section || el).getBoundingClientRect();
      const anchor = rect.top + Math.min(rect.height * 0.35, vh * 0.4);
      const progress = (anchor - vh / 2) / (vh * 0.85);
      // Invertido: scroll ↓ → cookie sobe; scroll ↑ → cookie desce
      const y = Math.max(-travel, Math.min(travel, -progress * travel));
      // Gira no sentido oposto ao scroll (↓ um lado, ↑ o outro)
      const rot = Math.max(-56, Math.min(56, -progress * 56));
      el.style.setProperty('--mk-orn-y', `${y.toFixed(2)}px`);
      el.style.setProperty('--mk-orn-rot', `${rot.toFixed(2)}deg`);
    });

    syncNina();
    ticking = false;
  };

  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  // capture:true — scroll NÃO borbulha; captura no document pega .page-wrapper e window
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });
  if (pageWrapper) {
    pageWrapper.addEventListener('scroll', onScroll, { passive: true });
  }

  requestAnimationFrame(() => {
    update();
    setTimeout(update, 150);
    setTimeout(update, 600);
  });
})();
